<template>
    <v-card elevation="1" style="min-height:250px; height: 250px; cursor: pointer;" @click="openModal">
      <v-card-title style="font-size: 1.1rem; font-weight: bold;">
        {{item.label}}
      </v-card-title>
      <v-card-subtitle style="font-size: 1rem;">
        {{item.count}} {{item.count === 1 ? 'annotation' : 'annotations'}}
      </v-card-subtitle>
      <v-card-text>
        <div class="container" :class="{ 'grouped-label-item__blur': sensitiveBlur }">
          <img style="min-height: 130px; max-height: 130px; max-width: 100%" :src="'data:image/png;base64, ' + item.data" />
          <div v-if="item.annotation_type === 2" class="centered white-font">+</div>
          <div v-if="item.annotation_type === 2" class="centered black-font">+</div>
        </div>
      </v-card-text>
    </v-card>
</template>

<script>
export default {
  props: {
    item: {required: true},
    sensitiveBlur: { type: Boolean, default: false },
  },
  methods: {
    openModal() {
      this.$emit('open_modal', this.item.label, this.item.count)
    }
  }
}
</script>

<style scoped>
  .container {
    position: relative;
    text-align: center;
  }
  .centered {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .white-font {
    font-size: 35px;
    color: rgba(255, 255, 255, 0.8);
  }
  .black-font {
    font-size: 30px;
    color: rgba(0, 0, 0, 0.6);
  }
  .grouped-label-item__blur img {
    filter: blur(28px);
    transform: scale(1.02);
  }
</style>

